import log from "../utils/logger/library";
import { init } from "@module-federation/enhanced/runtime";
import retryPlugin from "./runtimePlugins/retryPlugin";
import { ACC_CONFIG } from "./accountCentre";

// Initialize module federation
export const initMF = () => {
    try {
        init({
            name: "ocelot", // Name of the current host
            remotes: [
                {
                    name: ACC_CONFIG.scope,
                    entry: `${ACC_CONFIG.publicPath}/${ACC_CONFIG.remoteEntryPath}`,
                },
            ],
            plugins: [retryPlugin()],
        });
    } catch (error) {
        log.error("Failed to initialize module federation.", error);
    }
};
